import { CURRENCIES, TCurrency, TCurrencyCode } from "./markets";

const NODE_ENV = import.meta.env.VITE_NODE_ENV;
const clientAppUrl = import.meta.env.VITE_APP_URL;

export const CLIENT_APP_URL = clientAppUrl;
export const IS_DEV = NODE_ENV === "stage";

export const ALLOW_QA_OVERRIDES = import.meta.env.DEV || NODE_ENV === "stage";

export const aftershootMaxData = [
  {
    included: true,
    label:
      "<span class='font-semibold'>Unlimited Culling & Unlimited Editing</span>",
  },
  {
    included: true,
    label: "5 Personal AI Editing Profiles",
  },
  {
    included: true,
    label: "Access to 30+ AI Styles",
  },
  {
    included: true,
    label: "Access to Creator Styles",
  },
  {
    included: true,
    label: "Crop & Straighten",
  },
  {
    included: true,
    label: "Priority Onboarding",
  },
  {
    included: true,
    label: "1 License with 2 device logins",
  },
  {
    included: true,
    label: "Supports Lightroom Classic & Capture One",
  },
  {
    included: true,
    label: "Personal AI Editing Profile for additional $7 each",
  },

  // {
  //   included: true,
  //   label: "Crop and Straighten",
  // },
  // {
  //   included: true,
  //   label: "1+1 Seat Multiple Logins",
  // },

  {
    included: false,
    label: "<span class='font-medium'>Add-Ons -</span> Custom AI-styles",
  },
  {
    Included: false,
    label:
      "Preset Packs <span class='font-medium rounded-xs bg-black text-white text-xxs px-1 py-0.5'>COMING SOON</span> ",
  },
];

export const aftershootProData = [
  {
    included: true,
    label:
      "<span class='font-semibold'>Unlimited Culling & Unlimited Editing</span>",
  },
  {
    included: true,
    label: "Access to 30+ pre-built AI Styles",
  },
  {
    included: true,
    label: "Access to Creator Styles",
  },
  {
    included: true,
    label: "1 Personal AI Editing Profile",
  },
  {
    included: true,
    label: "Crop & Straighten",
  },
  {
    included: true,
    label: "Personal AI Editing Profile for additional $7 each",
  },
  {
    included: true,
    label: "Supports Lightroom Classic & Capture One",
  },
  {
    included: false,
    label: "Profile Adjustment",
  },
  {
    included: false,
    label: "1 Seat Multiple Login",
  },
  // {
  //   included: false,
  //   label: "1 Seat Multiple Logins",
  // },
  {
    included: false,
    label: "<span class='font-medium'>Add-ons -</span> Custom AI-styles",
  },
];

export const aftershootEditsData = [
  {
    included: true,
    label: "<span class='font-semibold'>Unlimited Edits</span>",
  },
  {
    included: true,
    label: "Access to 30+ pre-built AI Styles",
  },
  {
    included: true,
    label: "Access to Creator Styles",
  },
  {
    included: true,
    label: "Supports Lightroom Classic",
  },

  {
    included: true,
    label: "AI Crop & Straighten for additional $10",
  },
  {
    included: false,
    label: "Does not include Personal AI Editing Profiles",
  },
  // {
  //   included: false,
  //   label: "1 Seat Multiple Logins",
  // },
  // {
  //   included: false,
  //   label: "<span class='font-medium'>Add-ons -</span> Crop and Straighten",
  // },

  // {
  //   included: false,
  //   label: "Custom AI-styles",
  // },
];

export const aftershootSelectsData = [
  {
    included: true,
    label: "<span class='font-semibold'>Unlimited Culling</span>",
  },
  {
    included: true,
    label: "AI-Assisted Selections",
  },

  // {
  //   included: false,
  //   label: "AI Assisted Culling (coming soon)",
  // },
  {
    included: true,
    label:
      "<span> Duplicate <span class='font-semibold'>Detection</span></span>    ",
  },
  {
    included: false,
    label: "Does not include Editing",
  },
  // {
  //   included: false,
  //   label: "Key Faces Detection",
  // },
  // {
  //   included: false,
  //   label: "AI-Based Blur & Blink Detection",
  // },
  // {
  //   included: false,
  //   label: "Custom AI-styles",
  // },
  // {
  //   included: false,
  //   label: "Crop and Straighten",
  // },
];

export enum AftershootPlan {
  SELECTS = "Afteshoot Selects", //TODO:RENAME THIS TO ACTUAL VALUE BEFORE LIVE
  EDITS = "Aftershoot Edits Basic",
  BUNDLE = "Aftershoot Essentials",
  PRO = "Aftershoot Pro",
  MAX = "Aftershoot Max", // TODO:RENAME THIS TO ACTUAL VALUE BEFORE LIVE
  FOUNDERS = "Aftershoot Unlimited Founders Plan",
  TRIAL = "Aftershoot Pro Trial",
}

export enum StageProductIds {
  AftershootProTrial = "prod_Q4dhWPFWm32exk",
  AftershootSelects = "prod_Q4eWikVlArnU1x",
  AftershootEdits = "prod_Q4dp97FnKqBW9W",
  AftershootBundle = "prod_Q4dlDMk8IA5y4s",
  AftershootPro = "prod_Q4dhWPFWm32exk",
  AftershootMax = "prod_Q4e7l3t9q8Jupm",
  Croping_Straightening_Masking = "prod_OZ1bPvHgwKVKd4",
  Profile = "prod_OZ1cZhpkeJ8eTg",
  Retouching = "prod_U8ggEX65zCrNaL",
}

export enum ProductionProductIds {
  AftershootProTrial = "prod_OZ1XzQfrqLpeev",
  AftershootSelects = "prod_Jb6xfdWzwmGBVg",
  AftershootEdits = "prod_OZ1TKy0UQZHN0R",
  AftershootBundle = "prod_OZ1WlWUGsJwWxP",
  AftershootPro = "prod_OZ1XzQfrqLpeev",
  AftershootMax = "prod_N8cRjfhfYmtCnw",
  Croping_Straightening_Masking = "prod_OZ1bPvHgwKVKd4",
  Profile = "prod_OZ1cZhpkeJ8eTg",
  Retouching = "prod_U8ggEX65zCrNaL",
}

export const AftershootProductIds = IS_DEV
  ? StageProductIds
  : ProductionProductIds;

export const AftershootPlanIdMap: Record<string, string> = {
  prod_OVvyWA5iXzoJlN: "Trial",
  prod_Jb6xfdWzwmGBVg: "Selects",
  prod_OZ1TKy0UQZHN0R: "Edits",
  prod_OZ1WlWUGsJwWxP: "Bundle",
  prod_OZ1XzQfrqLpeev: "pro",
  prod_N8cRjfhfYmtCnw: "Max",
};

export enum AftershootPlanStatus {
  ACTIVE = "active",
  PAUSED = "paused",
  EXPIRED = "expired",
  TRIALING = "trialing",
  CANCELED = "canceled",
  NOT_FOUND = "not_found",
  PAST_DUE = "past_due",
}

export enum AftershootPlanRanking {
  SELECTS = 0,
  EDITS = 1,
  BUNDLE = 2,
  PRO = 3,
  FOUNDERS = 4,
  MAX = 4,
}

export const downgradeMaxtoPro = [
  `You'll lose your existing AI-styles`,
  `You'll lose access to multiple seats`,
];

export const downgradeMaxtoBundle = [
  "You'll lose access to all of your AI-styles",
  "You'll lose access to Crop and Straighten",
  "You'll lose access to 1 seat",
];

export const downgradeMaxtoSelects = [
  "You'll lose access to Marketplace",
  `You'll lose access to AI-based editing`,
  "You'll lose access to all of your AI-styles",
  "You'll lose access to Crop and Straighten",
  `You'll lose access to multiple seats`,
];

export const downgradeMaxtoEdits = [
  `You'll lose access to culling`,
  `You'll lose access to all your 5 AI-styles`,
  "You'll lose access to Crop and Straighten",
  "You'll lose access to 1 seat",
];

export const downgradeProtoBundle = [
  `You'll lose access to all of your AI Profile`,
  `You'll lose access to Crop and Straighten`,
];

export const downgradeProtoSelects = [
  `You'll lose access to AI-based editing`,
  "You'll lose access to Marketplace",
  "You'll lose access to all of your AI Profile",
  "You'll lose access to Crop and Straighten",
];

export const downgradeProtoEdits = [
  `You'll lose access to culling`,
  "You'll lose access to all of your AI Profile",
  "You'll lose access to Crop and Straighten",
];

export const downgradeBundletoSelects = [
  `You'll lose access to AI-based editing`,
  "You'll lose access to Marketplace",
];

export const downgradeBundletoEdits = [
  "You'll not be able to cull your images",
];

export const downgradeEditstoSelects = [
  "You'll not be able to do unlimited Edits",
  "You'll lose access to Marketplace",
];

export const DOWNGRADE_PLAN = {
  downgradeBundletoEdits,
  downgradeBundletoSelects,
  downgradeEditstoSelects,
  downgradeMaxtoBundle,
  downgradeMaxtoEdits,
  downgradeMaxtoPro,
  downgradeMaxtoSelects,
  downgradeProtoBundle,
  downgradeProtoEdits,
  downgradeProtoSelects,
};

export const cancelMax = [
  "You will lose access to unlimited editing",
  "You will lose access to unlimited culling",
  "You will lose access to all of your AI-styles",
  "You will lose access to additional Seats",
  "You will lose access to crop and straightening",
  "You will lose access to prebuilt profiles at marketplace",
];

export const cancelPro = [
  "You will lose access to unlimited editing",
  "You will lose access to unlimited culling",
  "You will lose access to all of your AI-styles",
  "You will lose access to crop and straightening",
  "You will lose access to prebuilt profiles at marketplace",
];

export const cancelBundle = [
  "You will lose access to unlimited editing",
  "You will lose access to unlimited culling",
  "You will lose access to prebuilt profiles at marketplace",
];

export const cancelEdits = [
  "You will lose access to unlimited editing",
  "You will lose access to prebuilt profiles at marketplace",
];

export const cancelSelects = ["You will lose access to unlimited culling"];

export const cancelPlans = {
  cancelBundle,
  cancelEdits,
  cancelMax,
  cancelPro,
  cancelSelects,
};

export const plansPricing = [
  {
    productId: AftershootProductIds.AftershootSelects,
    name: AftershootPlan.SELECTS,
    monthlyPrice: 15,
    yearlyPrice: 10,
    pricingName: AftershootPlan.SELECTS,
  },
  {
    productId: AftershootProductIds.AftershootEdits,
    name: AftershootPlan.EDITS,
    monthlyPrice: 18,
    yearlyPrice: 15,
    pricingName: AftershootPlan.EDITS,
  },
  {
    productId: AftershootProductIds.AftershootBundle,
    name: AftershootPlan.BUNDLE,
    monthlyPrice: 25,
    yearlyPrice: 20,
    pricingName: AftershootPlan.BUNDLE,
  },
  {
    productId: AftershootProductIds.AftershootPro,
    name: AftershootPlan.PRO,
    monthlyPrice: 48,
    yearlyPrice: 40,
    pricingName: AftershootPlan.PRO,
  },
  {
    productId: AftershootProductIds.AftershootMax,
    name: AftershootPlan.MAX,
    monthlyPrice: 72,
    yearlyPrice: 60,
    pricingName: AftershootPlan.MAX,
  },
];

export const BOOK_A_CALL_LINK =
  "https://calendly.com/product-experts-aftershoot?utm_source=website&utm_medium=aftershoot&utm_campaign=call_pricing_mar25";
export const BOOK_A_CALL_LINK_CANCELLATION =
  "https://calendly.com/product-experts-aftershoot?utm_source=banner&utm_medium=aftershoot&utm_campaign=call_in_app_cancel_mar25";

export const CONTACT_SUPPORT_LINK =
  "https://calendly.com/product-experts-aftershoot?utm_source=cancellation-web&utm_medium=cancellation-flow&utm_campaign=cancellation-flow";

//Special url for the AI Quality Concern
export const CONTACT_SUPPORT_FOR_AI =
  "https://calendly.com/product-experts-aftershoot?utm_source=cancellation-web&utm_medium=ai-quality-concern&utm_campaign=cancellation-flow";

export const CONTACT_SUPPORT_FOR_WORKSHOP =
  "https://aftershoot.com/live-workshops/?utm_source=cancellation-web&utm_medium=workshopcancellation-web&utm_campaign=cancellation-flow ";

export const BETA_URL_LINK =
  "https://aftershoot.com/retouching/?utm_source=cancellation-web&utm_medium=betalinkcancellation-web&utm_campaign=cancellation-flow";

export enum PLAN_CARD_ACTION {
  UPGRADE_NOW = "upgrade_now",
  SWITCH_TO_ANNUALLY = "switch_to_annually",
  SWITCH_PLAN = "switch_plan",
  MANAGE_SUBSCRIPTION = "manage_subscription",
  LOGIN_TO_START_TRIAL = "login_to_start_trial",
  BUY_NOW = "buy_now",
  PAUSE_PLAN = "pause_plan",
  RESUME_PLAN = "resume_plan",
  NOTHING = "nothing",
  CANCEL_PLAN = "cancel_plan",
  MANAGE_ADDONS = "manage_addons",
  CANCEL_CANCELLATION = "cancel_cancellation",
}

export enum PLAN_ACTION_COLOR {
  BLUE = "blue",
  DULL = "dull",
  ORANGE = "orange",
  GREEN = "green",
  WHITE = "white",
}

export enum APP_THEME {
  LIGHT = "light",
  DARK = "dark",
}

export enum APP_MODE {
  BLACKFRIDAY = "BLACKFRIDAY",
  CYBERMONDAY = "CYBERMONDAY",
  GREAT_WEDDING_SALE = "INDIAN_WEDDING_SALE",
  CANADA_SALE = "CANADA_SALE",
  BACK_TO_SEASON = "BACK_TO_SEASON",
  DARK = "DARK",
}

export const ALL_APP_MODE = Object.values(APP_MODE);
export const CUSTOM_STATUS_MODE = [APP_MODE.BLACKFRIDAY, APP_MODE.CYBERMONDAY];

export enum DEVICE_TYPE {
  DESKTOP = "desktop",
  MOBILE = "mobile",
  TABLET = "tablet",
}

export enum TAB_TYPE {
  GENERAL = "general",
  ACCOUNT = "account-details",
  REFERRAL = "referral-program",
  SECURITY = "security",
}

export const VERIFICATION_EMAIL_LS_KEY = "verification-email-sent";

export const ALTERNATIVE_TO_AFTERSHOOTS = [
  {
    value: "1",
    label: "Photomechanic",
    id: "a747c77c-a8ba-4770-a221-20c252c358d9",
  },
  {
    value: "2",
    label: "Narrative Select",
    id: "2f3a6966-1cc8-4706-8ffc-683515bed871",
  },
  {
    value: "3",
    label: "Lightroom",
    id: "d66034b9-cd57-417d-8b63-0eeb496c0f0f",
  },
  {
    value: "4",
    label: "Imagen AI",
    id: "28c32d54-aabf-4a58-abd0-af6325d950f2",
  },
  {
    value: "5",
    label: "Evoto",
    id: "004f649b-7be3-498b-91cb-016a2fd84a17",
  },
  {
    value: "6",
    label: "Capture One",
    id: "ed6faa7a-372b-4310-93e8-e9d7b853d5b4",
  },
  {
    value: "7",
    label: "Your Own",
    id: "b5f80fe0-fe5d-4da8-b36e-5a64f73de467",
  },
];
export enum COUNTRY_CODE {
  CA = "CA",
  US = "US",
  IN = "IN",
}

export const SUBSCRIPTION_PAUSE_LIMIT = 9;

export const TIME_THRESHOLD = 1;

export const MULTIPLIER_FOR_MONEY_SAVED = 40;

export const OPTIONS_MAP = {
  Pricing: "option1",
  Seasonality: "option2",
  TooConfusing: "option3",
  TechnicalIssue: "option4",
  MissingFeature: "option5",
  AIQualityConcerns: "option6",
  Others: "option7",
};

export const warningsByPlan = {
  [AftershootProductIds.AftershootSelects]: [
    `You will lose access to <b>Unlimited AI Culling</b>`,
    `You will lose access to <b>Duplicate Detection</b>`,
    `You will lose access to <b>AI-Assisted Culling</b>`,
  ],
  [AftershootProductIds.AftershootBundle]: [
    `You will lose access to <b>Unlimited AI Culling</b>`,
    `You will lose access to <b>Unlimited AI Editing</b>`,
    `You will lose access to <b>40+ Marketplace AI Styles</b>`,
    `You will lose access to <b>AI-Assisted Culling</b>`,
  ],
  [AftershootProductIds.AftershootPro]: [
    `You will lose access to <b>Unlimited AI Culling</b>`,
    `You will lose access to <b>Unlimited AI Editing</b>`,
    `You will lose access to <b>40+ Marketplace AI Styles</b>`,
    `You will lose access to <b>1 Personal AI Editing Styles</b>`,
  ],
  [AftershootProductIds.AftershootProTrial]: [
    `You will lose access to <b>Unlimited AI Culling</b>`,
    `You will lose access to <b>Unlimited AI Editing</b>`,
    `You will lose access to <b>40+ Marketplace AI Styles</b>`,
    `You will lose access to <b>1 Personal AI Editing Styles</b>`,
  ],
  [AftershootProductIds.AftershootMax]: [
    `You will lose access to <b>Unlimited AI Culling</b>`,
    `You will lose access to <b>40+ Marketplace AI Styles</b>`,
    `You will lose access to <b>5 Personal AI Editing Styles</b>`,
    `You will lose access to <b>AI Cropping, Straightening & Masking</b>`,
  ],
  [AftershootProductIds.AftershootEdits]: [
    `You will lose access to <b>Unlimited AI Editing</b>`,
    `You will lose access to <b>40+ Marketplace AI Styles</b>`,
    `You will lose access to <b>AI Cropping, Straightening & Masking</b>`,
  ],
};

export const missingFeatureByPlan = {
  [AftershootProductIds.AftershootSelects]: [
    `Unlimited AI Culling`,
    `Duplicate Detection`,
    `AI-Assisted Culling`,
  ],
  [AftershootProductIds.AftershootBundle]: [
    `Unlimited AI Culling`,
    `Unlimited AI Editing`,
    `40+ Marketplace AI Styles`,
    `AI-Assisted Culling`,
  ],
  [AftershootProductIds.AftershootPro]: [
    `Unlimited AI Culling`,
    `Unlimited AI Editing`,
    `40+ Marketplace AI Styles`,
    `1 Personal AI Editing Styles`,
  ],
  [AftershootProductIds.AftershootProTrial]: [
    `Unlimited AI Culling`,
    `Unlimited AI Editing`,
    `40+ Marketplace AI Styles`,
    `1 Personal AI Editing Styles`,
  ],
  [AftershootProductIds.AftershootMax]: [
    `Unlimited AI Culling`,
    `40+ Marketplace AI Styles`,
    `5 Personal AI Editing Styles`,
    `AI Cropping, Straightening & Masking`,
  ],
  [AftershootProductIds.AftershootEdits]: [
    `Unlimited AI Editing`,
    `40+ Marketplace AI Styles`,
    `AI Cropping, Straightening & Masking`,
  ],
};

export const PLAN_INTERVAL = {
  MONTH: "month",
  YEAR: "year",
} as const;

// The wire values the payment API uses for a subscription's billing cycle.
// `TBillingInterval` is derived from these.
export const BILLING_INTERVAL = {
  MONTHLY: "monthly",
  HALF_YEARLY: "half_yearly",
  YEARLY: "yearly",
  YEARLY_BILLED_MONTHLY: "annual_monthly",
} as const;

// The single placeholder for a value we cannot show — price, count or total.
export const NOT_AVAILABLE = "NA";

export const DEFAULT_CURRENCY: TCurrencyCode = "USD";

// Symbol to ISO code, inverted from `CURRENCIES`.
export const CURRENCY_CODE_MAP: Record<string, string> = Object.fromEntries(
  Object.entries<TCurrency>(CURRENCIES).map(([code, { symbol }]) => [
    symbol,
    code,
  ]),
);

// for indian users
export const REDIRECT_URL =
  "https://gro-390-great-wedding-sale.diyqqyh0iqcyc.amplifyapp.com/greatwedding";

export const EUROPEAN_COUNTRIES = [
  "AT", // Austria
  "BE", // Belgium
  "BG", // Bulgaria
  "HR", // Croatia
  "CY", // Cyprus
  "CZ", // Czech Republic
  "DK", // Denmark
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "HU", // Hungary
  "IE", // Ireland
  "IT", // Italy
  "LV", // Latvia
  "LT", // Lithuania
  "LU", // Luxembourg
  "MT", // Malta
  "NL", // Netherlands
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "SE", // Sweden
  "NO", // Norway
  "IS", // Iceland
  "LI", // Liechtenstein
  "GB", // United Kingdom
  "CH", // Switzerland
  "AD", // Andorra
  "AL", // Albania
  "AX", // Åland Islands
  "BA", // Bosnia and Herzegovina
  "BY", // Belarus
  "FO", // Faroe Islands
  "GG", // Guernsey
  "GI", // Gibraltar
  "IM", // Isle of Man
  "JE", // Jersey
  "MC", // Monaco
  "MD", // Moldova
  "ME", // Montenegro
  "MK", // North Macedonia
  "RS", // Serbia
  "RU", // Russia
  "SJ", // Svalbard and Jan Mayen
  "SM", // San Marino
  "UA", // Ukraine
  "VA", // Vatican City
  "XK", // Kosovo
] as const;

// EU outermost regions: GDPR applies, but they sit outside Europe geographically
const EU_OUTERMOST_REGIONS = [
  "GF", // French Guiana
  "GP", // Guadeloupe
  "MF", // Saint Martin
  "MQ", // Martinique
  "RE", // Réunion
  "YT", // Mayotte
] as const;

export const GDPR_COUNTRIES = [
  ...EUROPEAN_COUNTRIES,
  ...EU_OUTERMOST_REGIONS,
] as const;

const ASIAN_COUNTRIES = [
  "AE", // United Arab Emirates
  "AF", // Afghanistan
  "AM", // Armenia
  "AZ", // Azerbaijan
  "BD", // Bangladesh
  "BH", // Bahrain
  "BN", // Brunei
  "BT", // Bhutan
  "CN", // China
  "GE", // Georgia
  "HK", // Hong Kong
  "ID", // Indonesia
  "IL", // Israel
  "IN", // India
  "IO", // British Indian Ocean Territory
  "IQ", // Iraq
  "IR", // Iran
  "JO", // Jordan
  "JP", // Japan
  "KG", // Kyrgyzstan
  "KH", // Cambodia
  "KP", // North Korea
  "KR", // South Korea
  "KW", // Kuwait
  "KZ", // Kazakhstan
  "LA", // Laos
  "LB", // Lebanon
  "LK", // Sri Lanka
  "MM", // Myanmar
  "MN", // Mongolia
  "MO", // Macao
  "MV", // Maldives
  "MY", // Malaysia
  "NP", // Nepal
  "OM", // Oman
  "PH", // Philippines
  "PK", // Pakistan
  "PS", // Palestine
  "QA", // Qatar
  "SA", // Saudi Arabia
  "SG", // Singapore
  "SY", // Syria
  "TH", // Thailand
  "TJ", // Tajikistan
  "TL", // Timor-Leste
  "TM", // Turkmenistan
  "TR", // Turkey
  "TW", // Taiwan
  "UZ", // Uzbekistan
  "VN", // Vietnam
  "YE", // Yemen
] as const;

const AFRICAN_COUNTRIES = [
  "AO", // Angola
  "BF", // Burkina Faso
  "BI", // Burundi
  "BJ", // Benin
  "BW", // Botswana
  "CD", // DR Congo
  "CF", // Central African Republic
  "CG", // Congo
  "CI", // Côte d'Ivoire
  "CM", // Cameroon
  "CV", // Cabo Verde
  "DJ", // Djibouti
  "DZ", // Algeria
  "EG", // Egypt
  "EH", // Western Sahara
  "ER", // Eritrea
  "ET", // Ethiopia
  "GA", // Gabon
  "GH", // Ghana
  "GM", // Gambia
  "GN", // Guinea
  "GQ", // Equatorial Guinea
  "GW", // Guinea-Bissau
  "KE", // Kenya
  "KM", // Comoros
  "LR", // Liberia
  "LS", // Lesotho
  "LY", // Libya
  "MA", // Morocco
  "MG", // Madagascar
  "ML", // Mali
  "MR", // Mauritania
  "MU", // Mauritius
  "MW", // Malawi
  "MZ", // Mozambique
  "NA", // Namibia
  "NE", // Niger
  "NG", // Nigeria
  "RE", // Réunion
  "RW", // Rwanda
  "SC", // Seychelles
  "SD", // Sudan
  "SH", // Saint Helena
  "SL", // Sierra Leone
  "SN", // Senegal
  "SO", // Somalia
  "SS", // South Sudan
  "ST", // São Tomé and Príncipe
  "SZ", // Eswatini
  "TD", // Chad
  "TG", // Togo
  "TN", // Tunisia
  "TZ", // Tanzania
  "UG", // Uganda
  "YT", // Mayotte
  "ZA", // South Africa
  "ZM", // Zambia
  "ZW", // Zimbabwe
] as const;

// North America, including Central America and the Caribbean
const NORTH_AMERICAN_COUNTRIES = [
  "AG", // Antigua and Barbuda
  "AI", // Anguilla
  "AW", // Aruba
  "BB", // Barbados
  "BL", // Saint Barthélemy
  "BM", // Bermuda
  "BQ", // Bonaire, Sint Eustatius and Saba
  "BS", // Bahamas
  "BZ", // Belize
  "CA", // Canada
  "CR", // Costa Rica
  "CU", // Cuba
  "CW", // Curaçao
  "DM", // Dominica
  "DO", // Dominican Republic
  "GD", // Grenada
  "GL", // Greenland
  "GP", // Guadeloupe
  "GT", // Guatemala
  "HN", // Honduras
  "HT", // Haiti
  "JM", // Jamaica
  "KN", // Saint Kitts and Nevis
  "KY", // Cayman Islands
  "LC", // Saint Lucia
  "MF", // Saint Martin
  "MQ", // Martinique
  "MS", // Montserrat
  "MX", // Mexico
  "NI", // Nicaragua
  "PA", // Panama
  "PM", // Saint Pierre and Miquelon
  "PR", // Puerto Rico
  "SV", // El Salvador
  "SX", // Sint Maarten
  "TC", // Turks and Caicos Islands
  "TT", // Trinidad and Tobago
  "US", // United States
  "VC", // Saint Vincent and the Grenadines
  "VG", // British Virgin Islands
  "VI", // U.S. Virgin Islands
] as const;

const SOUTH_AMERICAN_COUNTRIES = [
  "AR", // Argentina
  "BO", // Bolivia
  "BR", // Brazil
  "CL", // Chile
  "CO", // Colombia
  "EC", // Ecuador
  "FK", // Falkland Islands
  "GF", // French Guiana
  "GY", // Guyana
  "PE", // Peru
  "PY", // Paraguay
  "SR", // Suriname
  "UY", // Uruguay
  "VE", // Venezuela
] as const;

const OCEANIAN_COUNTRIES = [
  "AS", // American Samoa
  "AU", // Australia
  "CC", // Cocos (Keeling) Islands
  "CK", // Cook Islands
  "CX", // Christmas Island
  "FJ", // Fiji
  "FM", // Micronesia
  "GU", // Guam
  "KI", // Kiribati
  "MH", // Marshall Islands
  "MP", // Northern Mariana Islands
  "NC", // New Caledonia
  "NF", // Norfolk Island
  "NR", // Nauru
  "NU", // Niue
  "NZ", // New Zealand
  "PF", // French Polynesia
  "PG", // Papua New Guinea
  "PN", // Pitcairn Islands
  "PW", // Palau
  "SB", // Solomon Islands
  "TK", // Tokelau
  "TO", // Tonga
  "TV", // Tuvalu
  "UM", // United States Minor Outlying Islands
  "VU", // Vanuatu
  "WF", // Wallis and Futuna
  "WS", // Samoa
] as const;

export const COUNTRY_CODES = [
  ...EUROPEAN_COUNTRIES,
  ...ASIAN_COUNTRIES,
  ...AFRICAN_COUNTRIES,
  ...NORTH_AMERICAN_COUNTRIES,
  ...SOUTH_AMERICAN_COUNTRIES,
  ...OCEANIAN_COUNTRIES,
];
